import { ReportColumnPersonalizationFlags } from '../columnUtils.types';
import { TicketGroupReportTableValueColumnId } from './ticketGroupColumnUtils.types';

export const TICKET_GROUP_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [TicketGroupReportTableValueColumnId.UnitCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [TicketGroupReportTableValueColumnId.TotalCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [TicketGroupReportTableValueColumnId.NumberOfTickets]: {
    isNumeric: true,
    isInteger: true,
  },
  [TicketGroupReportTableValueColumnId.SoldQuantity]: {
    isNumeric: true,
    isInteger: true,
  },
  [TicketGroupReportTableValueColumnId.UnsoldQuantity]: {
    isNumeric: true,
    isInteger: true,
  },
  [TicketGroupReportTableValueColumnId.Charges]: {
    isNumeric: true,
    isCurrency: true,
  },
  [TicketGroupReportTableValueColumnId.Credits]: {
    isNumeric: true,
    isCurrency: true,
  },
  [TicketGroupReportTableValueColumnId.SoldCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [TicketGroupReportTableValueColumnId.TotalNetProceeds]: {
    isNumeric: true,
    isCurrency: true,
  },
  [TicketGroupReportTableValueColumnId.PandL]: {
    isNumeric: true,
    isCurrency: true,
  },
  [TicketGroupReportTableValueColumnId.Margin]: {
    isNumeric: true,
    isPercent: true,
  },
};
